import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";
import { useForm } from "react-hook-form";
import { SelectField } from "../../../../atoms/FormFields";
import { useState } from "react";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
}

interface FormValues {
  preferredLanguage: string;
}

export default function PreferredLanguagePopUp(props: PropsType) {
  const { onClose } = props;
  const [loading, setLoading] = useState(false);
  const {
    control,
    formState: { errors, isDirty, isValid },
    handleSubmit,
  } = useForm<FormValues>();

  const onSubmit = (val: FormValues) => {
    console.log("val", val);
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      onClose();
    }, 2000);
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
      >
        <div className="modalWrapper">
          <div className="modal_header">
            <div className="title">
              <h2>Update preferred language</h2>
              <p>
                Select your language, and LandScaling will be displayed in it.
              </p>
            </div>
          </div>

          <div className="modal_content">
            <Row gutter={16}>
              <Col span={24} className="mb-0">
                <SelectField
                  fieldName="preferredLanguage"
                  label="Preferred language"
                  control={control}
                  defaultValue="English"
                  selectOption={[
                    { label: "English", value: "English" },
                    { label: "Spanish", value: "Spanish" },
                  ]}
                  iProps={{
                    placeholder: "Select language",
                  }}
                  isRequired
                  rules={{
                    required: "Language is required.",
                  }}
                  validate={errors.preferredLanguage && "error"}
                  validMessage={
                    errors.preferredLanguage && errors.preferredLanguage.message
                  }
                />
              </Col>
            </Row>
          </div>

          <div className="modal_footer">
            <Button
              htmlType="button"
              type="default"
              size="large"
              className="outlined-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              type="primary"
              size="large"
              className="mint-btn"
              disabled={!isDirty || !isValid}
            >
              Save changes
            </Button>
          </div>
        </div>
      </Form>
    </Spin>
  );
}
